import styled from "styled-components";

export const MessageErrorCustom = styled.span`
  color: #d32f2f;
  font-size: 12px;
`;
